import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentTabsInEventDto, IncidentEventTypeDto, IncidentTabsDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-incidenttabsinevent-container',
  templateUrl: './incidenttabsinevent-container.component.html',
  styleUrls: ['./incidenttabsinevent-container.component.scss']
})
export class IncidenttabsineventContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentTabsInEvents$: Observable<IncidentTabsInEventDto[]>;
  eventTypes$: Observable<IncidentEventTypeDto[]>;
  incidentTabs$: Observable<IncidentTabsDto[]>;
  loading: boolean;
  isLoadingIncidentTabsInEvent$: Observable<boolean>;
  isLoadingEventType$: Observable<boolean>;
  isLoadingIncidentTabs$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingIncidentTabsInEvent$ = this.gatwayFacade.isLoadingGateway("IncidentTabsInEvent");
    this.isLoadingEventType$ = this.gatwayFacade.isLoadingGateway("IncidentEventType");
    this.isLoadingIncidentTabs$ = this.gatwayFacade.isLoadingGateway("IncidentTabs");

    this.incidentTabsInEvents$ = this.gatwayFacade.loadGateway("IncidentTabsInEvent");
    this.eventTypes$ = this.gatwayFacade.loadGateway("IncidentEventType");
    this.incidentTabs$ = this.gatwayFacade.loadGateway("IncidentTabs");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentTabsInEvent(deletedValue: any) {
    this.gatwayFacade.remove("IncidentTabsInEvent", deletedValue);
  }


// this method control both the create and update

  onSubmitIncidentTabsInEvent(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentTabsInEvents;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllIncidentTabsInEvent = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentTabsInEvent.push(pullData[i]);
    }
  }

// check if the addAllIncidentTabsInEvent array is not empty, then dispatch the data to the store
   if(addAllIncidentTabsInEvent.length > 0) {
    this.gatwayFacade.add('IncidentTabsInEvent', addAllIncidentTabsInEvent);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('IncidentTabsInEvent', allUpdates, ['id']);
  }

   }

}
